<script setup lang="ts">
import type {IScheduledEvent} from "~/data/events";
import {useEventDateLeft} from "~/computed/useEventDateLeft";
import {isDone} from "~/functions/isDone";

const $props = defineProps<{
  scheduledEvent: IScheduledEvent
}>();

const {leftDaysText, leftDays, isOnline} = useEventDateLeft($props.scheduledEvent);
const isEventDone = isDone($props.scheduledEvent);
</script>

<template>
  <span v-if="!!leftDaysText"  class="left-days" :class="`left-days--${leftDays} ${isOnline ? 'left-days--online' : ''}`">{{ leftDaysText }}</span>
  <span v-else-if="isEventDone" class="left-days--done">Завершено</span>
</template>

<style scoped lang="scss">

</style>